import React, { useState } from 'react';
import { Modal, Form, Button, Image } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';


/* import config from json folder */
import options from "../../../assecs/json/select/level.json";

/* import function from store folder */
import { setModel } from '../../../store/components/modelSlice';

/* import element from component folder */
import Select from '../../../components/select';


const CreateLevelData = () => {
    const dispatch = useDispatch();
    const [error, setError] = useState({});
    const [source, setSource] = useState({});
    const [levelImage, setImage] = useState(null);
    const { data } = useSelector(state => state.model);
    
    const changHandler = ({target, target: { name, value, files }}) => {

        delete error[name];
        source[name] = value;

        if (name === 'type') {
            const selected = options.type.find(({ key }) => key === value);
            
            source.typeName = selected.value;
        }

        if (files) {
            source[name] = files[0];
            setImage(URL.createObjectURL(files[0]));
            target.value = null;
        }
        
        setError(error);
        setSource(source);
    };

    const validate = () => {
        const checkLists = ['level', 'type', 'value', 'minValue', 'checkHour', 'increaseValue'];
        const _errors = {};

        checkLists.map( list => (
            (!source[list]) && ( _errors[list] = true)
        ));
        
        if (Object.keys(_errors).length) {
            setError(_errors);
            return false;
        }

        return true;
    };

    const clearImage = () => {
        const _source = Object.assign({}, source);

        delete _source.newMonsterPhoto;
        
        setImage(null);
        setSource(_source);
    };

    const modelHandler = (buttonType, modelType) => {
        const _source = Object.assign({}, data);
        const config = { type: modelType };
        const isValidate = validate();

        if (isValidate || buttonType === 'cancel') {
            if (buttonType === 'submit'){
                source.eglId = new Date().getTime();
                _source.tableLists = [..._source.tableLists, source];
                config.data = _source;
            }

            dispatch(setModel(config));
        };
    };

    return (
        <Modal show={ true } centered size='lg'>
            <Modal.Header>Add Level Data</Modal.Header>
            <Modal.Body>
                <Form className="modal-form-container label-content">
                    <div className="form-item">
                        <div className='label'>Level</div>
                        <span className='semicolon'>：</span>
                        <Form.Control name='level' type='number' min={ 0 } placeholder='Please enter the level number.' is-required={ `${error.level}` } onChange={ changHandler } />
                    </div>
                    <div className="form-item">
                        <div className='label'>Type</div>
                        <span className='semicolon'>：</span>
                        <Select name='type' select_all={ false } shadow={ false } options={ options.type } required={ error.type } changHandle={ changHandler } />
                    </div>
                    <div className="form-item">
                        <div className='label'>Value</div>
                        <span className='semicolon'>：</span>
                        <Form.Control name='value' type='number' min={ 0 } placeholder='Please enter the value number.' is-required={ `${error.value}` } onChange={ changHandler } />
                    </div>
                    <div className="form-item">
                        <div className='label'>Per Check Hour Min Value</div>
                        <span className='semicolon'>：</span>
                        <Form.Control name='minValue' type='number' min={ 0 } placeholder='Please enter the check min value.' is-required={ `${error.minValue}` } onChange={ changHandler } />
                    </div>
                    <div className="form-item">
                        <div className='label'>Check Hour</div>
                        <span className='semicolon'>：</span>
                        <Form.Control name='checkHour' type='number' min={ 0 } placeholder='Please enter the check hour.' is-required={ `${error.checkHour}` } onChange={ changHandler } />
                    </div>
                    <div className="form-item">
                        <div className='label'>Unreached Increase Value</div>
                        <span className='semicolon'>：</span>
                        <Form.Control name='increaseValue' type='number' min={ 0 } placeholder='Please enter the unreached increase value.' is-required={ `${error.increaseValue}` } onChange={ changHandler } />
                    </div>
                    <div className="form-item">
                        <div className='label'>Description</div>
                        <span className='semicolon'>：</span>
                        <Form.Control name='description' placeholder='Please enter the description.' is-required={ `${error.description}` } onChange={ changHandler } />
                    </div>
                    <div className="form-item">
                        <div className='label'>Image</div>
                        <span className='semicolon'>：</span>
                        <div className="button-group">
                            <label className='btn' is-required={ `${error.newMonsterPhoto}` }>
                                <span>Choose File</span>
                                <input type="file" name='newMonsterPhoto' accept="image/png, image/jpeg" hidden onChange={ changHandler } />
                            </label> 
                            <Button type="button" onClick={ clearImage }>Unchoose File</Button>
                        </div>
                    </div>
                    <div className="form-item form-image-item">
                        { levelImage && <Image src={ levelImage } /> }
                    </div>
                    <div className="button-container">
                        <Button type="button" data-shadow onClick={ () => modelHandler('cancel', 'group-create') }>Cancel</Button>
                        <Button type="button" data-shadow onClick={ () => modelHandler('submit', 'group-create') }>Submit</Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    )
}

export default CreateLevelData;